var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 0.510742C13.3984 0.510742 14 1.1123 14 1.82324C14 2.26074 13.7812 2.64355 13.4531 2.88965L7.51953 7.34668C7.19141 7.59277 6.78125 7.59277 6.45312 7.34668L0.519531 2.88965C0.191406 2.64355 0 2.26074 0 1.82324C0 1.1123 0.574219 0.510742 1.3125 0.510742H12.6875ZM5.93359 8.05762C6.5625 8.52246 7.41016 8.52246 8.03906 8.05762L14 3.57324V9.26074C14 10.2451 13.207 11.0107 12.25 11.0107H1.75C0.765625 11.0107 0 10.2451 0 9.26074V3.57324L5.93359 8.05762Z",
    fill: "#F64A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.745be0bac270907bf1e3bc9fd4de58cb.svg";
export { ForwardRef as ReactComponent };